<template>
    <div class="header-wrapper" style="background-color: white;">
        <a class="header-item" href="/" title="数字集团">
            <img class="logo" src="@/assets/web/logo_pure_new.png"/>
            <img class="logo-white" src="@/assets/web/logo_pure_new.png"/>
        </a>
        <div class="menu">
            <!--菜单简化-->
            <div class="menu-item product-function has-child">
                <div class="s-box">
                    <el-link href="/case">典型案例</el-link>
                </div>
            </div>
            <div class="menu-item product-function has-child">
                <div class="s-box">
                    <el-link href="/price">价格体系</el-link>
                </div>
            </div>
            <div class="menu-item product-function has-child">
                <div class="s-box">
                    <el-link href="/join">加入我们</el-link>
                </div>
            </div>
        </div>
        <div class="right-wrapper">
            <div class="menu-item phone">
                <img src="@/assets/web/phone.png"/>
                <span>0594-2836688</span>
            </div>
            <div v-if="user&&user.userId && user.username !== 'yanshi'">
                <a class="menu-item signin" @click="HostUtil.gotoAdmin('/flowApp/index')" title="工作台">工作台</a>
                <a class="menu-item register" @click="handleLogout" title="退出">退出</a>
            </div>
            <div v-else>
                <a class="menu-item signin" @click="handleLogin" title="登录">登录</a>
                <a class="menu-item register" @click="handleApply" title="注册">注册</a>
            </div>
        </div>
        <org-apply ref="orgApply"></org-apply>
    </div>
</template>

<script>
import OrgApply from './apply.vue'
import UserUtil from "@/utils/user";
import {isMobile} from "@/utils";
import HostUtil from "@/utils/host";

export default {
    name: 'WebTop',
    components: {OrgApply},
    data: function () {
        return {
            user: {userId: null},
            loading: true,
            scrollTop: 0
        }
    },
    computed: {
        HostUtil() {
            return HostUtil
        }
    },
    mounted() {
        this.user = UserUtil.getPrincipal()
    },
    created() {
        this.$nextTick(() => {
        })
    },
    methods: {
        handleApply() {
            if (isMobile()) {
                this.$router.push({path: '/register'})
            } else {
                this.$refs.orgApply.dialog = true
            }

        },
        handleLogin() {
            if (isMobile()) {
                this.$message.warning('请通过电脑端获得体验！')
            } else {
                UserUtil.logout()
                HostUtil.gotoAdmin('/login')
            }
        },
        handleLogout() {
            this.$confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                UserUtil.logout()
                this.$router.go()
            })
        }
    }
}

var _hmt = _hmt || [];
(function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?0dbca4dc3e9a9a5e43996094b60f5f02";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();
</script>
